function BurgerMenuLink(scope, element, attrs) {
	var $el = $(element);
	$el.on('click', function() {
		var $this = $(this);
		var $wrapper = $('.hamburger', $this);

		if (!$wrapper.hasClass('is-active')) {
			$this.addClass('expanded');
		} else {
			$this.removeClass('expanded');
		}

		setTimeout(function() {
			$wrapper.toggleClass('is-active');
		}, 200);
	});
}

 


/* @ngInject */ 
export default function BurgerMenu($templateCache) {
	var templateString = $templateCache.get('templates/flyout-menu/burger-menu.html');

	return {
		restrict: 'E',
		link: BurgerMenuLink,
		template: templateString
	};
}
